import { EntityBooleanPlugin } from './EntityBooleanPlugin';
import { EntityDatePlugin } from './EntityDatePlugin';
import { EntityEnumPlugin } from './EntityEnumPlugin';
import { EntityIntegerPlugin } from './EntityIntegerPlugin';
import { EntityJsonbPlugin } from './EntityJsonbPlugin';
import { EntityNumericPlugin } from './EntityNumericPlugin';
import { EntityTextPlugin } from './EntityTextPlugin';
import { EntityTimePlugin } from './EntityTimePlugin';
import { EntityTimestampPlugin } from './EntityTimestampPlugin';
export const defaultEntityPlugins = [
    EntityTextPlugin,
    EntityIntegerPlugin,
    EntityBooleanPlugin,
    EntityTimestampPlugin,
    EntityDatePlugin,
    EntityTimePlugin,
    EntityEnumPlugin,
    EntityNumericPlugin,
    EntityJsonbPlugin
];
//# sourceMappingURL=default.js.map